import React, { useRef, useCallback, useState, useEffect, Fragment } from 'react';
import { withStyles } from '@material-ui/core';
import { PrintSection } from './components';

/**
 * @see docs/features/PRINT_REPORT.md — ag-Grid print integration
 */
const PrintReport = ({ classes, gridApi, setPrintRef, getPrintDataFn }) => {
  const printRef = useRef(null);
  const gridApiRef = useRef(null);
  const [printData, setPrintData] = useState({
    printSections: null,
    pageBreakBetweenSections: true,
    ReportHeader: <></>,
    rowData: [],
    columns: [],
    kpiData: []
  });

  useEffect(() => {
    gridApiRef.current = gridApi;
  }, [gridApi]);

  // This function that will be called before printing
  const onBeforeGetContent = useCallback(() => {
    return new Promise((resolve) => {
      if (gridApiRef.current && getPrintDataFn) {
        const printData = getPrintDataFn()(gridApiRef.current);
        setPrintData(printData);
      }
      resolve();
    });
  }, [getPrintDataFn]);

  useEffect(() => {
    setPrintRef?.(printRef, onBeforeGetContent);
  }, [setPrintRef, onBeforeGetContent]);

  const hasGroupedSections = printData.printSections?.length > 0;

  return (
    <div className={classes.hideContainer}>
      <div ref={printRef}>
        {hasGroupedSections
          ? printData.printSections.map((section, sectionIndex) => (
              <Fragment key={sectionIndex}>
                {printData.pageBreakBetweenSections && sectionIndex > 0 && (
                  <div className={classes.pageBreak} />
                )}
                <PrintSection
                  reportHeader={section.ReportHeader}
                  columns={section.columns}
                  rowData={section.rowData}
                  kpiData={section.kpiData}
                  tableClassName={classes.table}
                />
              </Fragment>
            ))
          : (
              <PrintSection
                reportHeader={printData.ReportHeader}
                columns={printData.columns}
                rowData={printData.rowData}
                kpiData={printData.kpiData}
                tableClassName={classes.table}
              />
            )}
      </div>
    </div>
  );
};

const styles = (_theme) => ({
  table: {
    margin: 0,
    marginTop: 16,
    tableLayout: 'fixed',
    borderSpacing: 0,
  },
  hideContainer: {
    display: 'none',
  },
  pageBreak: {
    pageBreakBefore: 'always',
  },
});

export default withStyles(styles)(React.memo(PrintReport));
